document.body.classList.add('pk-home-active');
const root = document.querySelector('.pk-home');
const button = document.querySelector('.menu-toggle');
const nav = document.querySelector('#pk-main-nav');
const mobileCtaLinks = Array.from(document.querySelectorAll('.mobile-cta a'));

const normalizeCtaLabels = () => {
  document.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href') || '';
    const text = link.textContent.trim();
    const isPlanningLink = /meine-umfrage|livorno-polsterkonfigurator/i.test(href);
    const isPlanningAction = link.matches('a.button, .mobile-cta a') || /vorplanen/i.test(text);
    if (isPlanningLink && isPlanningAction) {
      link.textContent = link.classList.contains('text-link') ? 'Planung starten →' : 'Planung starten';
    } else if (/beratung/i.test(href) && /Beratung (kennenlernen|buchen)|Kostenlose Beratung/i.test(text)) {
      link.textContent = '20-Min-Beratung buchen';
    }
  });
  if (mobileCtaLinks[0]) mobileCtaLinks[0].textContent = 'Planung starten';
  if (mobileCtaLinks[1]) mobileCtaLinks[1].textContent = 'Beratung buchen';
};

const addHeaderActions = () => {
  const header = document.querySelector('.site-header');
  const primary = header?.querySelector(':scope > a.button-small');
  if (!header || !primary || header.querySelector('.pk-header-actions')) return;

  const adviceSource = Array.from(document.querySelectorAll('footer a, .mobile-cta a')).find((link) => {
    const href = link.getAttribute('href') || '';
    return /(?:[?&]view=beratung|#beratung-buchen)/i.test(href);
  });
  if (!adviceSource) return;

  const actions = document.createElement('div');
  actions.className = 'pk-header-actions';
  header.insertBefore(actions, primary);
  primary.textContent = 'Planung starten';
  primary.classList.add('pk-header-plan');
  actions.appendChild(primary);

  const advice = document.createElement('a');
  advice.className = 'button button-small button-header-advice';
  advice.href = adviceSource.href;
  advice.textContent = '20 Minuten Beratung buchen';
  actions.appendChild(advice);
};

const addMobileNavActions = () => {
  if (!nav || nav.querySelector('.pk-mobile-nav-actions')) return;
  const primary = mobileCtaLinks[0];
  const secondary = mobileCtaLinks[1];
  const contact = Array.from(document.querySelectorAll('footer a')).find((link) => /\/contact(?:[?#]|$)/.test(link.getAttribute('href') || ''));
  if (!primary && !secondary && !contact) return;

  const actions = document.createElement('div');
  actions.className = 'pk-mobile-nav-actions';
  [
    [primary, 'Planung starten', 'is-primary'],
    [secondary, 'Beratung buchen', 'is-secondary'],
    [contact, 'Kontakt aufnehmen', 'is-contact'],
  ].forEach(([source, label, className]) => {
    if (!source) return;
    const link = document.createElement('a');
    link.href = source.href;
    link.textContent = label;
    link.className = className;
    actions.appendChild(link);
  });
  nav.appendChild(actions);
};

const attributionKeys = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
  'campaign_id', 'adset_id', 'ad_id', 'fbclid', 'fbc', 'fbp', 'tracking_test'
];

const getAttributionValue = (key) => {
  if (!window.PKPrivacy?.marketingAllowed()) return '';
  const currentValue = new URLSearchParams(window.location.search).get(key) || '';
  if (currentValue) {
    try { sessionStorage.setItem(`pk-attribution-${key}`, currentValue); } catch (_) {}
    return currentValue;
  }
  try { return sessionStorage.getItem(`pk-attribution-${key}`) || ''; } catch (_) { return ''; }
};

const appendAttributionToPlanningLinks = () => {
  const attribution = attributionKeys
    .map((key) => [key, getAttributionValue(key)])
    .filter(([, value]) => value);
  if (!attribution.length) return;

  document.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href') || '';
    if (!/meine-umfrage|livorno-polsterkonfigurator/i.test(href)) return;
    const targetUrl = new URL(link.href, window.location.origin);
    attribution.forEach(([key, value]) => targetUrl.searchParams.set(key, value));
    link.href = targetUrl.toString();
  });
};

normalizeCtaLabels();
addHeaderActions();
addMobileNavActions();
appendAttributionToPlanningLinks();
document.addEventListener('visitorConsentCollected', appendAttributionToPlanningLinks);
document.addEventListener('pk:privacy-ready', appendAttributionToPlanningLinks);

const prepareCalmReveals = () => {
  if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const items = root.querySelectorAll('main > section, #pk-main > section, .model-card, .pk-model-showcase-card, .pk-guide-card');
  items.forEach((item) => item.classList.add('pk-reveal'));
  root.classList.add('pk-reveal-ready');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  items.forEach((item) => {
    if (item.getBoundingClientRect().top < window.innerHeight * 0.9) item.classList.add('is-visible');
    else observer.observe(item);
  });
};

prepareCalmReveals();

button?.addEventListener('click', () => {
  const open = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!open));
  nav?.classList.toggle('open', !open);
});
nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
  button.setAttribute('aria-expanded', 'false');
  nav.classList.remove('open');
}));

let scrollTicking = false;
const updateCompactHeader = () => {
  root?.classList.toggle('pk-header-compact', window.scrollY > 24);
  scrollTicking = false;
};
window.addEventListener('scroll', () => {
  if (scrollTicking) return;
  scrollTicking = true;
  window.requestAnimationFrame(updateCompactHeader);
}, { passive: true });
updateCompactHeader();

const trackConfiguratorStart = (link) => {
  if (!window.PKPrivacy?.analyticsAllowed()) return;
  const details = {
    link_text: (link.textContent || 'Planung starten').trim(),
    link_url: link.href || link.getAttribute('href') || '',
    page_location: window.location.href,
    page_path: window.location.pathname,
    transport_type: 'beacon'
  };
  if (window.Shopify?.analytics?.publish) {
    window.Shopify.analytics.publish('configurator_start', details);
  }
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'configurator_start', details);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'configurator_start', ...details });
  }
};

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const href = link.getAttribute('href') || '';
  const text = (link.textContent || '').trim();
  const opensConfigurator = /meine-umfrage|livorno-polsterkonfigurator|#pk-configurator/i.test(href);
  if (opensConfigurator && /planung starten/i.test(text)) trackConfiguratorStart(link);
});
